import React, { useState } from "react";
import helperNumbers from "../../../../helpers/numbers";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import ListUserCustomerCoWorker from "../../user/ListUserCustomerCoWorker";
import AllBanner from "./AllBanner";

export default function SelectCustomerForAllAdvertise() {
  const [user, setUser] = useState();
  const [message, setMessage] = useState();

  const findUser = async () => {
    const userID = document.querySelector("#user-id").value;
    let user = ListUserCustomerCoWorker.filter((user) => userID == user.id);
    user = user[0];
    if (!user) {
      setMessage({
        type_class: "alert alert-danger",
        text: "کاربر موجود نیست.",
        class_icon: "fa fa-exclamation-triangle",
      });
      setUser();
      return;
    }
    setUser({
      ...user,
      user_id: userID,
    });
    setMessage();
  };

  let messageTag;
  if (message) {
    messageTag = (
      <div key={Math.random()} className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const generateUserInfo = () => {
    return (
      <div>
        <div className="table-responsive py-2">
          <table className="table table-hilite tbl-td-white-space w-100">
            <thead>
              <tr>
                <td>نام کاربر</td>
                <td>ایمیل کاربر</td>
                <td>شماره موبایل کاربر</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {user.first_name} {user.last_name}
                </td>
                <td>{user.email}</td>
                <td dir="ltr">
                  {user.mobile != undefined
                    ? helperNumbers.toPersianNum(
                        helperNumbers.presentMobileNumber(user.mobile)
                      )
                    : ""}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <AllBanner userID={user.user_id} />
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="all-advertise" activeItem="add-advertise-banner" />

      <div className="content-wrapper">
        <TitleBar title="کمپین ها" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="card-body px-2" id="list-customer">
                {messageTag}
                <div>
                  <div className="alert alert-warning ">
                    <p className="text-justify">
                      <i className="fa fa-info pl-2"></i>
                      توجه داشته باشید :{" "}
                    </p>
                    <ul className="pr-3">
                      <li>
                        <p className="text-justify">
                          جهت ساخت یا مشاهده گروه نمایش دهنده ابتدا شماره کاربر
                          مورد نظر خود را از{" "}
                          <a
                            className="text-primary"
                            style={{ textDecoration: "none" }}
                            target="_blank"
                            href="/user/all-customer-coworker"
                          >
                            بخش کاربران
                          </a>{" "}
                          پیدا کرده و در زیر وارد کنید.
                        </p>
                      </li>
                      <li>
                        <p className="text-justify">
                          شماره کاربر مورد نظر خود را با اعداد لاتین وارد
                          نمایید.
                        </p>
                      </li>
                      <li>
                        <p className="text-justify">
                          تاریخ شروع و تاریخ پایان کمپین شما برابر با تاریخ شروع
                          و پایان گروه نمایش دهنده شما میباشد.
                        </p>
                      </li>
                      <li>
                        <p className="text-justify">
                          جهت مشاهده یا ویرایش گروه نمایش دهنده ساخته شده از قبل
                          میتوانید عملیات اقدام نمایید.
                        </p>
                      </li>
                    </ul>
                  </div>

                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      findUser();
                    }}
                  >
                    <div className="input-group mb-3 w-fit-content">
                      <input
                        onWheel={(event) => event.currentTarget.blur()}
                        type="number"
                        id="user-id"
                        className="form-control"
                        placeholder="شماره کاربر را وارد کنید."
                        required
                      />
                      <div className="input-group-append">
                        <button
                          className="btn btn-info"
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            findUser();
                          }}
                        >
                          پیدا کردن کاربر
                        </button>
                      </div>
                    </div>
                  </form>

                  {user && generateUserInfo()}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
